import { createContext, use } from "react";

import type { ControlClient } from "@magicweave/api";

/**
 * Split from provider.tsx so that file exports only components.
 *
 * React Fast Refresh works per module: a file that exports a component and a
 * hook cannot be hot-reloaded, so every edit to a screen reloads the whole app
 * and loses its state. That is a small cost repeated hundreds of times a day.
 */
export const ClientContext = createContext<ControlClient | null>(null);

export function useApi(): ControlClient {
  const client = use(ClientContext);
  if (!client) throw new Error("useApi must be used inside an ApiProvider");
  return client;
}
